<template>
  <!-- ROUTOVACI SKUPINY NA DETAILU ENDPOINTU -->
  <div class="list-page">
    <div
      :class="{ 'layout__content__header--white': full, 'p-0': !full }"
      class="layout__content__header list-page__header"
    >
      <h1 v-if="full">
        {{ $t("routovaciSkupiny") }}
      </h1>
      <div v-if="project" class="d-flex justify-content-between">
        <div class="d-flex list-page__left align-items-center">
          <div
            v-if="project.projectId"
            class="custom-control custom-control--search d-flex align-items-center justify-content-between list-page__search"
          >
            <input
              id="guisearch"
              ref="searchInput"
              v-model="search"
              :placeholder="this.$t('Hledat podle názvu, ID, tagu, …')"
              autofocus
              class="w-100"
              type="text"
              @keyup.enter="searchGroups()"
            />
            <div v-if="search" class="atom-icon" @click="clearSearch()">
              <img src="@/assets/icons/actions/ico-close.svg" />
            </div>
            <div class="atom-icon last" @click="searchGroups()">
              <img src="@/assets/icons/actions/ico-search-black.svg" />
            </div>
            <div class="custom-control--search__suggestions">
              <div
                v-for="(suggestion, index) in suggestionsArray"
                :key="index"
                class="custom-control--search__suggestions__item"
                @click="setSuggestion(suggestion)"
              >
                <span>{{ suggestion }}</span>
              </div>
            </div>
          </div>
          <!--div class="list-page__link">
            <a class="d-flex align-items-center">
              {{ $t("pokrocilaFiltrace") }}
              <img src="@/assets/icons/arrows/arr-orange-down.svg" class="">
            </a>
          </div-->
        </div>
        <div v-if="full" class="list-page__buttons d-flex align-items-center justify-content-end">
          <button
            v-if="project.projectId"
            class="btn btn-primary d-flex align-items-center justify-content-center"
            @click="toggleNewGroup()"
          >
            <div class="atom-icon">
              <img src="@/assets/icons/actions/ico-btn-nova.svg" />
            </div>
            {{ $t("novyEndpoint") }}
          </button>
        </div>
      </div>
    </div>
    <div v-if="groups && groups.length > 0" :class="{ 'px-0': !full }" class="layout__content__content pt-5">
      <div v-if="selectable" v-click-outside="closeDropdownActions" class="dropdown-actions">
        <button v-if="selectedRows.length > 0" class="btn btn-primary" @click="showDropdownActions()">
          <div class="d-flex align-items-center">
            {{ $t("hromadneAkce") }}
            <img class="ml-2" src="@/assets/icons/arrows/arr-down-white.svg" />
          </div>
        </button>
        <button v-else class="btn btn-primary" disabled>
          <div class="d-flex align-items-center">
            {{ $t("hromadneAkce") }}
            <img class="ml-2" src="@/assets/icons/arrows/arr-down-white.svg" />
          </div>
        </button>
        <div v-if="isActionsDropdownVisible" class="dropdown-actions__wrapper dropdown-actions__wrapper--small">
          <div class="dropdown-actions__inner">
            <div class="row">
              <!--b-col cols="12" class="dropdown-actions__item d-flex align-items-center">
                <div class="atom-icon">
                  <img src="@/assets/icons/actions/ico-ico-label.svg">
                </div>
                {{ $t("pridatTag") }}
              </b-col>
              <b-col cols="12" class="dropdown-actions__item d-flex align-items-center">
                <div class="atom-icon">
                  <img src="@/assets/icons/actions/ico-ico-label.svg">
                </div>
                {{ $t("odebratTag") }}
              </b-col-->
              <div
                class="dropdown-actions__item d-flex align-items-center col-12"
                @click="
                  () => {
                    actionItems = selectedRows
                    toggleAddEndpointsModal('addToEndpoints')
                  }
                "
              >
                <div class="atom-icon">
                  <img src="@/assets/icons/actions/ico-ico-zmenaskupiny.svg" />
                </div>
                {{ $t("priraditEndpoint") }}
              </div>
              <div
                class="dropdown-actions__item d-flex align-items-center"
                cols="12"
                @click="
                  () => {
                    actionItems = selectedRows
                    toggleRemoveEndpointsModal('removeEndpoints')
                  }
                "
              >
                <div class="atom-icon">
                  <img src="@/assets/icons/actions/ico-ico-zmenaskupiny.svg" />
                </div>
                {{ $t("odebratEndpoint") }}
              </div>
              <!--
              <b-col
                cols="12"
                class="dropdown-actions__item d-flex align-items-center"
                @click="
                  actionItems = selectedRows;
                  toggleRemoveEndpointFromGroup(selectedRows);
                  isActionsDropdownVisible = false;
                "
              >
                <div class="atom-icon">
                  <img src="@/assets/icons/actions/ico-ico-delete-l.svg" />
                </div>
                {{ $t("smazatSkupinu") }}
              </b-col>
              -->
            </div>
          </div>
        </div>
      </div>
      <div v-if="selectable" class="d-flex align-items-center justify-content-end mb-4">
        <span class="font-weight-light">{{ $t("vybrano") }}: {{ selectedRows.length }}</span>
        <span v-if="selectedRows.length !== groups.length" class="link ml-4" @click="selectAll('selectAll')">
          {{ $t("vybratVse") }}
        </span>
        <span v-if="selectedRows.length > 0" class="link ml-2" @click="selectAll('deselect')">
          {{ $t("OdvybratVse") }}
        </span>
      </div>

      <div class="position-relative w-100">
        <div id="groups" class="table-responsive">
          <table class="table table-main table-hover">
            <thead>
              <tr>
                <th
                  v-for="(column, index) in columns"
                  :key="index"
                  :class="{ isHidden: !column.visible }"
                  :style="{ 'min-width': column.minWidth }"
                >
                  <span v-if="!column.sortable">{{ $t(column.name) }} at</span>
                  <span v-else>
                    <div
                      v-if="column.name === 'deviceGroupName'"
                      :class="{ checked: allOnPageSelected() }"
                      class="custom-control custom-control--checkbox"
                      @click="selectAll()"
                    >
                      <input class="custom-control-input" type="checkbox" />
                    </div>
                    <div class="title" @click="sortBy(column.type)">
                      {{ $t(column.name) }}
                    </div>
                    <div v-if="sort === column.type" class="sorting">
                      <span v-if="sortType === 'desc'">▼</span>
                      <span v-if="sortType === 'asc'">▲</span>
                    </div>
                  </span>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, item_index) in groups.slice(
                  this.page * Number(this.rowsPerPage),
                  this.page * Number(this.rowsPerPage) + Number(this.rowsPerPage)
                )"
                :key="item_index"
              >
                <td
                  v-for="(column, column_index) in columns"
                  :key="column_index"
                  :class="{
                    isHidden: !column.visible
                  }"
                  :style="{ width: column.minWidth }"
                >
                  <span v-if="column.type === 'deviceGroupName'">
                    <div
                      :class="{
                        checked: selectedRows.filter((e) => e.deviceGroupId === item.deviceGroupId).length > 0
                      }"
                      class="custom-control custom-control--checkbox"
                      style="display: inline-block"
                      @click="addToSelected(item)"
                    >
                      <input class="custom-control-input" type="checkbox" />
                    </div>

                    <RouterLink
                      :to="{
                        name: 'group',
                        params: {
                          id: item.deviceGroupId,
                          group: item
                        }
                      }"
                      class="font-weight-bolder link-gray"
                    >
                      <span :style="{ maxWidth: column.minWidth }" style="display: block; word-wrap: break-word">
                        {{ item[column.type] }}
                      </span>
                    </RouterLink>
                  </span>
                  <span v-else-if="column.type === 'deviceGroupDesc'">
                    <div v-tooltip :title="item.deviceGroupDesc">
                      <span>{{ item.deviceGroupDesc }}</span>
                    </div>
                  </span>
                  <span v-else-if="column.type === 'devices'">
                    {{ item.devices }}
                  </span>
                  <div v-else-if="column.type === 'endpoints'">
                    {{ item.endpoints }}
                  </div>
                  <span v-else>
                    {{ item[column.type] }}
                  </span>
                </td>
                <td>
                  <div
                    id="kebab"
                    ref="kebab"
                    :class="{
                      opened: openedGroup.deviceGroupId === item.deviceGroupId
                    }"
                    class="kebab"
                  />
                </td>
              </tr>
            </tbody>
          </table>

          <table :class="{ showShadow: showShadow }" class="table table-hover fixed-first-column">
            <thead>
              <tr>
                <th>
                  <span v-if="columns[0].sortable !== true">
                    {{ $t(columns[0].name) }}
                  </span>
                  <span v-else class="d-flex align-items-center">
                    <div
                      v-if="columns[0].name === 'deviceGroupName'"
                      :class="{
                        checked: allOnPageSelected()
                      }"
                      class="custom-control custom-control--checkbox"
                      @click="selectAll()"
                    >
                      <input class="custom-control-input" type="checkbox" />
                    </div>
                    <div class="title" @click="sortBy(columns[0].type)">
                      {{ $t(columns[0].name) }}
                    </div>
                    <div v-if="sort === columns[0].type" class="sorting">
                      <span v-if="sortType === 'desc'">▼</span>
                      <span v-if="sortType === 'asc'">▲</span>
                    </div>
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, item_index) in groups.slice(
                  this.page * Number(this.rowsPerPage),
                  this.page * Number(this.rowsPerPage) + Number(this.rowsPerPage)
                )"
                :key="item_index"
              >
                <td :style="{ width: columns[0].minWidth }">
                  <span>
                    <div
                      :class="{
                        checked: selectedRows.filter((e) => e.deviceGroupId === item.deviceGroupId).length > 0
                      }"
                      class="custom-control custom-control--checkbox"
                      style="display: inline-block"
                      @click="addToSelected(item)"
                    >
                      <input class="custom-control-input" type="checkbox" />
                    </div>

                    <RouterLink
                      :to="{
                        name: 'group',
                        params: {
                          id: item.deviceGroupId,
                          group: item,
                          customerId: customerId,
                          projectId: projectId
                        }
                      }"
                      class="font-weight-bolder link-gray"
                    >
                      <span :style="{ maxWidth: columns[0].minWidth }" style="display: block; word-wrap: break-word">
                        {{ item.deviceGroupName }}
                      </span>
                    </RouterLink>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>

          <table :class="{ showShadow: showShadow }" class="table table-hover fixed-last-column">
            <thead>
              <tr>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, item_index) in groups.slice(
                  this.page * Number(this.rowsPerPage),
                  this.page * Number(this.rowsPerPage) + Number(this.rowsPerPage)
                )"
                :key="item_index"
              >
                <td>
                  <div
                    id="kebab"
                    ref="kebab"
                    :class="{
                      opened: openedGroup.deviceGroupId === item.deviceGroupId
                    }"
                    class="kebab"
                  >
                    <div class="dropdown-actions">
                      <div class="atom-icon mr-0" @click="openKebab(item)">
                        <img src="@/assets/icons/menu/ico-kebab.svg" />
                      </div>
                      <div
                        v-if="openedGroup.deviceGroupId === item.deviceGroupId"
                        v-click-outside="closeKebabConf"
                        class="dropdown-actions__wrapper"
                      >
                        <div class="dropdown-actions__inner">
                          <div
                            class="dropdown-actions__item d-flex align-items-center"
                            @click="
                              () => {
                                actionItems = [openedGroup]
                                toggleEditGroupModal('editGroup')
                              }
                            "
                          >
                            <div class="atom-icon">
                              <img src="@/assets/icons/actions/ico-ico-zmenaskupiny.svg" />
                            </div>
                            {{ $t("upravitSkupinu") }}
                          </div>
                          <div
                            class="dropdown-actions__item d-flex align-items-center"
                            cols="6"
                            @click="
                              () => {
                                actionItems = [openedGroup]
                                toggleRemoveEndpointFromGroup([item])
                              }
                            "
                          >
                            <div class="atom-icon">
                              <img src="@/assets/icons/actions/ico-ico-delete-l.svg" />
                            </div>
                            {{ $t("odebratSkupinuOdEndpointu") }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div v-if="groups.length > 0" class="custom-table__footer d-flex align-items-center justify-content-between">
        <div class="custom-table__footer__actions align-items-center" />
        <Paging
          :page="{
            currentPage: page,
            rowsPerPage: rowsPerPage,
            itemsTotalCount: groups.length,
            itemsCount: groups.length
          }"
          @page="page = $event"
          @next-page="page++"
          @prev-page="page--"
          @rows-per-page="rowsPerPage = $event"
        />
      </div>
    </div>

    <div v-else class="layout__content__content pt-4 pt-md-5">
      {{ $filters.firstUpper($t("zadneSkupinyKZobrazeni")) }}
    </div>
    <NewGroupModal
      :opened="openedNewGroup"
      @close-box="toggleNewGroupModal"
      @open-box="toggleNewGroupModal"
      @reload-items="$emit('updateGroups')"
    />
    <RemoveEndpointFromGroupModal
      :centered="true"
      :items="actionItems"
      :opened="openedRemoveGroup"
      :text="removeText"
      @close="toggleRemoveEndpointFromGroup()"
      @yes="
        () => {
          removeEndpointFromGroup()
          toggleRemoveEndpointFromGroup()
        }
      "
      @update-items="$emit('updateGroups')"
    />
    <AddEndpointModal
      :devices="actionItems"
      :opened="openedAddEndpoints"
      @close-box="toggleAddEndpointsModal"
      @open-box="toggleAddEndpointsModal"
      @update-items="$emit('updateGroups')"
    />
    <RemoveEndpointModal
      :devices="actionItems"
      :opened="openedRemoveEndpoints"
      @close-box="toggleRemoveEndpointsModal"
      @open-box="toggleRemoveEndpointsModal"
      @update-items="$emit('updateGroups')"
    />
    <EditGroupModal
      :device="actionItems[0]"
      :opened="openedEditGroup"
      @close-box="toggleEditGroupModal"
      @open-box="toggleEditGroupModal"
      @reload-items="$emit('updateGroups')"
    />
    <div v-if="openedError">
      <ErrorModal :centered="true" :errors="errorsToTranslate" :opened="openedError" @close="openedError = false" />
    </div>
  </div>
</template>

<script>
import axios from "axios"
//import _ from "lodash";
import Paging from "@/components/paging/paging.vue"
import RemoveEndpointFromGroupModal from "@/components/confirmations/remove.vue"
import AddEndpointModal from "@/components/modals/groups/addEndpoint.vue"
import RemoveEndpointModal from "@/components/modals/groups/removeEndpoint.vue"
import NewGroupModal from "@/components/modals/groups/new.vue"
import EditGroupModal from "@/components/modals/groups/edit.vue"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import { useProjectStore } from "@/store/modules/project"

export default {
  directives: {},
  components: {
    Paging,
    RemoveEndpointFromGroupModal,
    AddEndpointModal,
    RemoveEndpointModal,
    NewGroupModal,
    EditGroupModal,
    ErrorModal
  },
  props: {
    groups: Array,
    selectedRows: Array,
    full: Boolean,
    selectable: Boolean,
    endpoint: Object,
    customerId: String,
    projectId: String
  },
  emits: ["updateGroups", "sortBy", "search", "clearSearch"],
  setup() {
    const projectStore = useProjectStore()

    return { projectStore }
  },
  data() {
    return {
      tableWidth: 0,
      columns: [
        {
          type: "deviceGroupName",
          name: "deviceGroupName",
          sortable: true,
          visible: true,
          minWidth: "250px",
          order: 1
        },
        {
          type: "deviceGroupDesc",
          name: "popisSkupiny",
          sortable: false,
          visible: true,
          minWidth: "450px",
          order: 1
        },
        {
          type: "devices",
          name: "devices",
          sortable: true,
          visible: true,
          minWidth: "100px",
          order: 2
        },
        {
          type: "endpoints",
          name: "MENU_VYSTUPY",
          sortable: true,
          visible: true,
          minWidth: "100px",
          order: 3
        }
      ],
      selectedProject: JSON.parse(localStorage.getItem("selectedProject")),
      selectedCustomer: JSON.parse(localStorage.getItem("selectedCustomer")),
      openedGroup: {},
      openedGroupTags: [],
      isHeaderFixed: false,
      isTableHeaderFixed: false,
      sort: "deviceGroupName",
      sortType: "asc",
      search: "",
      suggested: "",
      suggestionsArray: [],
      //selectedRows: [],
      selectedAll: false,
      isSelectedAllOnPage: false,
      isActionsDropdownVisible: false,
      rowsPerPage: 20,
      page: 0,
      openedRowsSelect: false,
      toggledAllRows: false,
      loaded: false,
      sortedGroups: [],
      openedRemoveGroup: false,
      removeText: "",
      openedAddEndpoints: [],
      openedRemoveEndpoints: [],
      openedNewGroup: [],
      openedEditGroup: [],
      actionItems: [],
      errorsToTranslate: [],
      openedError: false,
      closeKebabConf: {
        handler: this.closeKebab,
        middleware: this.middlewareKebab,
        events: ["dblclick", "click"],
        isActive: true,
        detectIFrame: true,
        capture: false
      },
      tableColumnsDefault: {
        deviceGroupDesc: {
          show: true,
          order: 2,
          title: "popisSkupiny"
        },
        devices: {
          show: true,
          order: 3,
          title: "devices"
        },
        endpoints: {
          show: true,
          order: 4,
          title: "MENU_VYSTUPY"
        }
      },
      showSidebarTableColumnOrder: false,
      tableColumns: {},
      showShadow: false
    }
  },
  computed: {
    project() {
      return this.projectStore.selectedProject
    }
  },
  watch: {
    search() {
      if (this.suggested === "") {
        if (this.search.length > 1) {
          this.suggestions()
        }
      } else {
        this.suggested = ""
      }
    },
    rowsPerPage() {
      this.page = 0
      localStorage.rowsPerPage = this.rowsPerPage
    },
    page() {
      this.isSelectedAllOnPage = false
      var selectedGroups = this.groups.slice(
        this.page * this.rowsPerPage,
        this.page * this.rowsPerPage + this.rowsPerPage
      )
      let selectedGroupsId = selectedGroups.map((d) => d.custDestId)
      let selectedAllRowsArray = Array.from(this.selectedRows)
      let groupsId = selectedAllRowsArray.map((d) => d.custDestId)
      this.isSelectedAllOnPage = selectedGroupsId.every((ai) => groupsId.includes(ai))
    },
    groups() {
      this.$nextTick(() => {
        this.updateResponsiveTable()
      })
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.updateResponsiveTable)
      window.addEventListener("click", this.updateResponsiveTable)
    })

    if (localStorage.rowsPerPage) {
      this.rowsPerPage = localStorage.rowsPerPage
    } else {
      localStorage.rowsPerPage = this.rowsPerPage
    }

    this.updateResponsiveTable()

    const tabsElement = document.getElementById("tabs")
    window.document.onscroll = () => {
      if (tabsElement) {
        this.isHeaderFixed = window.scrollY > tabsElement.offsetTop + 250
      }
    }
  },
  unmounted() {
    window.document.onscroll = undefined
  },
  methods: {
    updateResponsiveTable() {
      this.$updateResponsiveTable(this, "groups")
    },
    /*     sortBy(sortingParam) {
      this.selectedRows = [];
      this.$emit("sortBy", sortingParam);
    }, */
    sortBy(sortingParam) {
      this.selectedRows = []
      this.$emit("sortBy", sortingParam)
      this.sort = sortingParam

      if (this.sortType === "asc") {
        this.sortType = "desc"
      } else {
        this.sortType = "asc"
      }
    },
    toggleTag(group) {
      var index = this.openedGroupTags.indexOf(group)
      if (this.openedGroupTags.indexOf(group) > -1) {
        this.openedGroupTags.splice(index, 1)
      } else {
        this.openedGroupTags.push(group)
      }
    },
    copyToClipboard(text) {
      var input = document.createElement("textarea")
      input.innerHTML = text
      document.body.appendChild(input)
      input.select()
      var result = document.execCommand("copy")
      document.body.removeChild(input)
      return result
    },
    openKebab(group) {
      this.openedGroup = this.openedGroup === group ? {} : group
    },
    closeKebab() {
      this.openedGroup = {}
    },
    searchGroups() {
      this.$emit("search", this.search)
      this.suggestionsArray = []
    },
    suggestions() {
      axios
        .get(
          process.env.VUE_APP_API +
            "/device-groups/suggestions?projectId[eq]=" +
            this.selectedProject.projectId +
            "&search=" +
            this.search +
            "*"
        )
        .then((response) => {
          this.suggestionsArray = response.data.data
        })
        .catch(() => {})
    },
    setSuggestion(suggestion) {
      this.suggested = suggestion
      this.search = suggestion
      this.searchGroups()
      this.suggestionsArray = []
    },
    clearSearch() {
      this.search = ""
      this.suggested = ""
      this.$emit("clearSearch")
    },
    selectAll(type) {
      this.isSelectedAllOnPage = true
      var selectedGroups = this.groups.slice(
        this.page * this.rowsPerPage,
        this.page * this.rowsPerPage + this.rowsPerPage
      )

      let selectedGroupsId = selectedGroups.map((d) => d.deviceGroupId)
      let selectedAllRowsArray = Array.from(this.selectedRows)
      let groupsId = selectedAllRowsArray.map((d) => d.deviceGroupId)
      if (type === "deselect") {
        this.selectedRows = []
        this.isSelectedAllOnPage = false
      } else if (type === "selectAll") {
        this.selectedRows = [].concat.apply([], this.groups)
        this.isSelectedAllOnPage = true
      } else {
        if (selectedGroupsId.every((ai) => groupsId.includes(ai))) {
          let indexes = []
          selectedGroups.forEach((element) => {
            indexes.push(selectedAllRowsArray.indexOf(element))
          })

          this.selectedRows.splice(indexes[0], indexes.length)
        } else {
          this.selectedRows =
            this.selectedRows.length > 0
              ? this.selectedRows.concat.apply(this.selectedRows, selectedGroups)
              : [].concat.apply([], selectedGroups)
        }
      }
    },
    allOnPageSelected() {
      let itemsOnPage = this.groups.slice(
        this.page * this.rowsPerPage,
        Number(this.page * this.rowsPerPage) + Number(this.rowsPerPage)
      )

      let itemsOnPageId = itemsOnPage.map((d) => d.deviceGroupId)
      let allItemsId = Array.from(this.selectedRows).map((d) => d.deviceGroupId)

      return itemsOnPageId.every((ai) => allItemsId.includes(ai))
    },
    addToSelected(group) {
      var index = this.selectedRows.indexOf(group)
      if (this.selectedRows.indexOf(group) > -1) {
        this.selectedRows.splice(index, 1)
      } else {
        this.selectedRows.push(group)
      }
    },
    showDropdownActions() {
      this.isActionsDropdownVisible = !this.isActionsDropdownVisible
    },
    toggleOpenedRowSelect() {
      this.openedRowsSelect = !this.openedRowsSelect
    },
    toggleAllRows() {
      if (this.toggledAllRows) {
        this.openedGroupTags = []
        this.toggledAllRows = false
      } else {
        this.openedGroupTags = [].concat.apply([], this.groups)
        this.toggledAllRows = true
      }
    },
    toggleRemoveEndpointFromGroup(items) {
      console.log("toggleRemoveGroup")
      console.log(this.endpoint)
      if (this.openedRemoveGroup === true) {
        this.openedRemoveGroup = false
        this.removeText = ""
      } else {
        if (items) {
          if (items.length > 1 && items.length < 5) this.removeText = this.$t("skupiny")
          else if (items.length >= 5) this.removeText = this.$t("skupin")
          else this.removeText = items[0].deviceGroupName
        }
        this.openedRemoveGroup = true
      }
    },
    removeEndpointFromGroup() {
      this.errorsToTranslate = []
      let promises = []
      let notifications = []
      this.actionItems.forEach((item) => {
        let id = item.deviceGroupId
        promises.push(
          axios
            .delete(
              process.env.VUE_APP_API + "/device-groups/" + id + "/endpoints/" + this.endpoint.custDestId + "/assign",
              {}
            )
            .then((response) => {
              if (response.status === 204) {
                notifications.push({
                  text: "notificationEndpointGroupRemove",
                  error: false,
                  params: {
                    custDestId: this.endpoint.custDestId,
                    custDestName: this.endpoint.custDestName,
                    deviceGroupId: item.deviceGroupId,
                    deviceGroupName: item.deviceGroupName
                  }
                })
                this.sortedGroups.splice(this.sortedGroups.indexOf(item), 1)
                this.selectedRows.splice(this.selectedRows.indexOf(item), 1)
                this.groups.splice(this.groups.indexOf(item), 1)
                this.endpoint.deviceGroups.splice(this.endpoint.deviceGroups.indexOf(item), 1)
              }
            })
            .catch((error) => {
              let message = error.data.errors[0]
              error.data.errors = []
              error.data.errors.push({
                message: message,
                attribute: {
                  deviceGroupName: item.deviceGroupName,
                  deviceGroupId: item.deviceGroupId
                }
              })
              this.errorsToTranslate.push(error.data)
            })
        )
      })
      Promise.all(promises).then(() => {
        this.$emit("updateGroups")
        this.$store.commit("modals/setGlobalNotification", notifications)
        this.openedError = true
      })
    },
    toggleNewGroupModal(box) {
      if (this.openedNewGroup.indexOf(box) > -1) {
        if (box === undefined) {
          this.openedNewGroup = []
        } else {
          this.openedNewGroup.filter((b) => b !== box)
        }
        this.isActionsDropdownVisible = false
      } else {
        this.openedNewGroup = this.openedNewGroup.concat([box])
      }
    },
    toggleEditGroupModal(box) {
      if (this.openedEditGroup.indexOf(box) > -1) {
        if (box === undefined) {
          this.openedEditGroup = []
        } else {
          this.openedEditGroup = this.openedEditGroup.filter((b) => b !== box)
        }
        this.isActionsDropdownVisible = false
      } else {
        this.openedEditGroup = this.openedEditGroup.concat([box])
      }
    },
    toggleAddEndpointsModal(box) {
      if (this.openedAddEndpoints.indexOf(box) > -1) {
        if (box === undefined) {
          this.openedAddEndpoints = []
        } else {
          this.openedAddEndpoints = this.openedAddEndpoints.filter((b) => b !== box)
        }
        this.isActionsDropdownVisible = false
      } else {
        this.openedAddEndpoints = this.openedAddEndpoints.concat([box])
      }
    },
    toggleRemoveEndpointsModal(box) {
      if (this.openedRemoveEndpoints.indexOf(box) > -1) {
        if (box === undefined) {
          this.openedRemoveEndpoints = []
        } else {
          this.openedRemoveEndpoints = this.openedRemoveEndpoints.splice(this.openedRemoveEndpoints.indexOf(box), 1)
        }
        this.isActionsDropdownVisible = false
      } else {
        this.openedRemoveEndpoints = this.openedRemoveEndpoints.concat([box])
      }
    },
    closeDropdownActions() {
      this.isActionsDropdownVisible = false
    },
    middleware(event) {
      return event.target.className !== "kebab"
    },
    closeSidebarTableColumnOrder() {
      this.tableColumns = this.getTableColumns()
      this.showSidebarTableColumnOrder = false
      this.$nextTick(() => {
        this.updateResponsiveTable()
      })
    },
    getTableColumns() {
      const localStorageItemsJSON = localStorage.getItem(this.columnsTypeName)
      if (!localStorageItemsJSON) {
        return this.tableColumnsDefault
      }

      const localStorageItems = JSON.parse(localStorageItemsJSON)

      if (Object.keys(localStorageItems).length === 0) {
        return this.tableColumnsDefault
      }
      return localStorageItems
    }
  }
}
</script>

<style scoped></style>
